export default "__VITE_ASSET__DrxkO_s___"